import React from 'react';
import { Form } from 'react-final-form';
import { useSelector } from 'react-redux';

import validate from '../../../../utils/validate';
import Navig8FormInner from './Navig8FormInner';
import { replyYopValidation } from './validation';

function Navig8Form({ onReply }) {
  const hint = useSelector((state) => state.sonarDashboard.navig8.hint);

  const repliesFormInitialValues = {
    hint: hint,
    reply: '',
  };

  const handleReplyNavig8 = (values) => {
    onReply({ reply: values.reply });
  };

  return (
    <Form
      initialValues={repliesFormInitialValues}
      onSubmit={handleReplyNavig8}
      subscription={{ submitting: true, pristine: true }}
      validateOnBlur={false}
      validate={(values) => validate(values, replyYopValidation())}
      render={({ handleSubmit }) => <Navig8FormInner onSubmit={handleSubmit} />}
    />
  );
}

export default Navig8Form;
